import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { BookOpen, Users, LayoutDashboard, FileText, LogOut, ChevronRight, UserCircle } from "lucide-react";
import NotificationBell from "./NotificationBell";
import pnup from "../assets/pnup.png";

const roleLabels = { admin: "Administrator", mahasiswa: "Mahasiswa", dosen: "Dosen Pembimbing" };
const roleColors = { admin: "bg-purple-100 text-purple-700", mahasiswa: "bg-blue-100 text-blue-700", dosen: "bg-green-100 text-green-700" };

const navItems = {
  admin: [
    { icon: LayoutDashboard, label: "Dashboard", id: "dashboard" },
    { icon: Users, label: "Kelola Pengguna", id: "users" },
    // { icon: FileText, label: "Semua Bimbingan", id: "bimbingan" },
  ],
  mahasiswa: [
    { icon: LayoutDashboard, label: "Dashboard", id: "dashboard" },
    { icon: FileText, label: "Riwayat Bimbingan", id: "history" },
    { icon: BookOpen, label: "Input Bimbingan", id: "input" },
    { icon: UserCircle, label: "Edit Profil", id: "profil" },
  ],
  dosen: [
    { icon: LayoutDashboard, label: "Dashboard", id: "dashboard" },
    { icon: Users, label: "Mahasiswa Saya", id: "students" },
    // { icon: FileText, label: "Semua Bimbingan", id: "pending" },
    { icon: UserCircle, label: "Edit Profil", id: "profil" },
  ],
};

export default function Sidebar({ activeTab, onTabChange }) {
  const { user, logout } = useAuth();
  if (!user) return null;

  const items = navItems[user.role] || [];

  return (
    <aside className="w-64 min-h-screen bg-[#002147] flex flex-col fixed left-0 top-0 z-10">
      {/* Logo */}
      <div className="p-6 border-b border-white/10">
        <div className="flex items-center gap-2">
          <div className="w-14 h-14 shrink-0 flex items-center justify-center overflow-hidden">
            <img  src={pnup} alt="PNUP Logo" className="w-full h-full object-contain" /> 
          </div>
          <div>
            <h1 className="text-white/50  text-sm leading-tight font-[Outfit]">Monitoring Tugas Akhir</h1>
            <p className="text-white font-bold text-xs">D4 TEKNOLOGI REKAYASA JARINGAN TELEKOMUNIKASI</p>
          </div>
        </div>
      </div>

      {/* User Info */}
      <div className="p-4 border-b border-white/10">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-sm bg-white/20 flex items-center justify-center flex-shrink-0">
            <span className="text-white font-bold text-sm">{user.name?.[0]?.toUpperCase() || "U"}</span>
          </div>
          <div className="min-w-0">
            <p className="text-white text-sm font-semibold truncate font-[Manrope]">{user.name}</p>
            <span className={`text-xs px-2 py-0.5 rounded-sm font-medium ${roleColors[user.role]}`}>
              {roleLabels[user.role]}
            </span>
          </div>
          <div className="ml-auto flex-shrink-0">
            <NotificationBell />
          </div>
        </div>
        {user.nim && <p className="text-white/50 text-xs mt-1 ml-12">NIM: {user.nim}</p>}
        {user.nip && <p className="text-white/50 text-xs mt-1 ml-12">NIP: {user.nip}</p>}
      </div>

      {/* Nav */}
      <nav className="flex-1 p-3 space-y-1">
        {items.map(item => {
          const active = activeTab === item.id;
          return (
            <button
              key={item.id}
              data-testid={`sidebar-nav-${item.id}`}
              onClick={() => onTabChange(item.id)}
              className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm font-medium transition-all duration-200 font-[Manrope] ${
                active
                  ? "bg-white text-[#002147]"
                  : "text-white/70 hover:bg-white/10 hover:text-white"
              }`}
            >
              <item.icon size={16} strokeWidth={active ? 2.5 : 2} />
              <span>{item.label}</span>
              {active && <ChevronRight size={14} className="ml-auto" />}
            </button>
          );
        })}
      </nav>

      {/* Logout */}
      <div className="p-3 border-t border-white/10">
        <button
          data-testid="logout-button"
          onClick={logout}
          className="w-full flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm text-white/70 hover:bg-red-500/20 hover:text-red-300 transition-all duration-200 font-[Manrope]"
        >
          <LogOut size={16} />
          <span>Keluar</span>
        </button>
      </div>
    </aside>
  );
}
